module.exports = __webpack_public_path__ + "static/media/logo.ba673e38.svg";